import { Button, CardActions, Stack } from "@mui/material";

import { CbhCustomChatMessage } from "@src/appV2/Chat/CbhCustomChatMessage";
import { CoreMessageType } from "@sendbird/uikit-react/types/utils";
import { useHistory } from "react-router-dom";
import { getLocation } from "@src/utils/routes";
import { ChatChannel } from "../chat.types";

interface PlacementApplicationMessageProps {
  message: CoreMessageType;
  currentChannel: ChatChannel;
}

export function PlacementApplicationInterviewScheduledMessage({
  message,
  currentChannel,
}: PlacementApplicationMessageProps) {
  const history = useHistory();
  const chatMessage = message as CoreMessageType & { message: string };
  const { hcpName } = currentChannel.metadata ?? {};

  if (!chatMessage.message) {
    return null;
  }

  function navigateToManageJobsPage() {
    history.push(
      getLocation("manageJobs", {
        queryParams: {
          ...(hcpName ? { searchApplicant: hcpName } : {}),
        },
      })
    );
  }

  return (
    <CbhCustomChatMessage
      message={chatMessage.message}
      avatarSxProps={{ justifyContent: "flex-start" }}
      messageContainerSxProps={{ width: "50%" }}
    >
      <CardActions>
        <Stack sx={{ padding: 1 }} spacing={2} alignItems="flex-start">
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button variant="contained" onClick={navigateToManageJobsPage}>
              Manage jobs
            </Button>
          </Stack>
        </Stack>
      </CardActions>
    </CbhCustomChatMessage>
  );
}
